<template>
  <the-header-menu />
    <el-container class="reusable-page">

      <div class="lnd-cover">
        <h1 class="lnd-headline">Kontakt</h1>
      </div>

      <div class="main-content">
        <el-page-header content="Kontakt" @back="goBack" title="Zpět" />
        <div class="content">
        <div class="l-kontakt-adresa-w">
            
            <div style="min-width: 40%; padding-right: 30px">
                <h5>Adresa</h5>
                <p><strong>Aeroklub Kroměříž</strong><br>
                Na Hrázi 1148 <br>
                Kroměříž <br>
                767 01 <br> <br>

                <strong>IČ: </strong>18190235
                </p>
                <h5>Bankovní spojení</h5>
                <p><strong>Fio banka a.s.: </strong>2500558624/2010</p>
            </div>
            <div style="flex-grow:1; position: relative;">
              <div style="position: absolute; bottom:-40px; left: 0px;">
                <el-radio-group v-model="map_toggle" size="small">
                  <el-radio-button label="true" >Mapy.cz</el-radio-button>
                  <el-radio-button label="false">Google Maps</el-radio-button>
                </el-radio-group>
              </div>
              <iframe v-if="map_toggle != 'true'" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10409.082737464834!2d17.4168274!3d49.2902153!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xcbe9075cd76ccdd7!2zQWVyb2tsdWIgS3JvbcSbxZnDrcW-!5e0!3m2!1sen!2scz!4v1643475465145!5m2!1sen!2scz" ></iframe>
              <iframe v-if="map_toggle == 'true'" style="border:none" src="https://frame.mapy.cz/s/jumazejelu" width="100%" height="100%" frameborder="0"></iframe>
            </div>
        </div>

        <h5 style="padding-top: 40px;">Zavolejte nám</h5>
          <div class="l-kontakt-lide">
              <div class="l-kontakt-kontakt-w">
                <div >
                    <span><strong>Předseda AK - členství</strong></span><br>
                    <span>Radek Ligurský ml.</span><br>
                    <span>+420 735 192 886</span>
                </div>
              </div>
              <div class="l-kontakt-kontakt-w">
                <div>
                    <span><strong>Výcvik - SPL</strong></span><br>
                    <span>Zdeněk Balcárek</span><br>
                    <span>+420 776 862 777</span>
                </div>
              </div>
              <div class="l-kontakt-kontakt-w">
                <div>
                    <span><strong>Výcvik - ULL</strong></span><br>
                    <span>Radek Ligurský st.</span><br>
                    <span>+420 723 021 106</span>
                </div>
              </div>
              <div class="l-kontakt-kontakt-w">
                <div>
                    <span><strong>VLP</strong></span><br>
                    <span>Miroslav Rakušan</span><br>
                    <span>+420 603 259 545</span>
                </div>
              </div>
              <div class="l-kontakt-kontakt-w">
                <div>
                    <span><strong>Lety pro veřejnost</strong></span><br>
                    <span>Radek Ligurský st.</span><br>
                    <span>+420 723 021 106</span><br><br>
                    <span>Ludvík Kunetka</span><br>
                    <span>+420 776 680 890</span><br><br>
                </div>
              </div>
              <!-- <div class="l-kontakt-kontakt-w">
                <div>
                    <span><strong></strong></span><br>
                    <span></span><br>
                    <span></span>
                </div>
              </div> -->
        </div>

        <h5 style="padding-top: 20px;">Napište nám</h5>
        <p>V případě jakýkoliv dotazů využijte kontaktní formulář, nebo nám napište na emailovou adresu <a href="mailto:aeroklub@lkkm.cz" style="color: black; text-decoration: none;"><strong>aeroklub@lkkm.cz</strong></a>.</p>

        <the-form-kontakt />
        </div>
      </div>
      <the-footer />
    </el-container>
</template>

<script>

import TheHeaderMenu from '../components/TheHeaderMenu3.vue'
import TheFooter from '../components/TheFooter.vue'
import TheFormKontakt from '../components/TheFormKontakt.vue'

import { useRouter } from 'vue-router'
import { ref } from '@vue/reactivity'


export default {
    name: "PageKontakt",
    components: {
      TheHeaderMenu,
      TheFooter,
      TheFormKontakt
    },
    setup(){
      const router = useRouter();
      const map_toggle = ref("true");

      function goBack(){
        router.back()
      }

      // let kontakty = [
      //   {
      //     "pozice": "Předseda AK - členství",
      //     "jmeno": "Radek Ligurský ml.",
      //     "cislo": "+420 735 192 886"
      //   },
      //   {
      //     "pozice": "Výcvik - SPL",
      //     "jmeno": "Zdeněk Balcárek",
      //     "cislo": "+420 776 862 777"
      //   },
      //   {
      //     "pozice": "Výcvik - ULL",
      //     "jmeno": "Radek Ligurský st.",
      //     "cislo": "+420 723 021 106"
      //   },
      //   {
      //     "pozice": "Výcvik - ULL",
      //     "jmeno": "Radek Ligurský st.",
      //     "cislo": "+420 723 021 106"
      //   },
      //   {
      //     "pozice": "Lety pro veřejnost",
      //     "jmeno": "Radek Ligurský st.",
      //     "cislo": "+420 723 021 106"
      //   },        
      //   {
      //     "pozice": "VLP",
      //     "jmeno": "Miroslav Rakušan",
      //     "cislo": "+420 603 259 545"
      //   }        
      // ]
      return {goBack, /*kontakty,*/ map_toggle}
    }
}
</script>


<style scoped>


.l-kontakt-kontakt-w{
    width: 180px;
    display: flex;
    flex-direction: row;
    align-content: center;
    padding-bottom: 30px;
}

.l-kontakt-lide{
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.l-kontakt-adresa-w{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 30px;
}



.main-content{

  width: 90%;
  padding-top: 20px;
  padding-bottom: 30px;
}
.content{
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
  /* box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px; */
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}

.lnd-cover{
  width: 100%;
  height: 300px;
  background-image: url("../../src/assets/cover/ingkaspar.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
.lnd-headline{
  text-align: center;
  position: relative;
  top: 40%;
}

.reusable-page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  height: 100%;
  width: 100%;
}

</style>